<template>
  <div>
    <h1>DashBoard</h1>
  </div>
</template>

<script>
export default {
  name: "DashBoardPage",
  methods: {
    handleClick() {
      console.log("clicked");
    }
  }
};
</script>
